import { render, staticRenderFns } from "./BaseTooltip.vue?vue&type=template&id=530f9666&scoped=true"
import script from "./BaseTooltip.vue?vue&type=script&lang=js"
export * from "./BaseTooltip.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "530f9666",
  null
  
)

export default component.exports